import GameCard from "../components/GameCard";

export default function UserHome() {
  const games = [
    { title: "AVIATOR", img: "/icons/plane.png", url: "/aviator" },
    { title: "LUDO", img: "/assets/roll.png", url: "/ludo" },
    { title: "CHESS", img: "/assets/chess.png", url: "/chess" },
    { title: "HEADTAIL", img: "/assets/headtail.png", url: "/headtail" },
    { title: "TEENPATTI", img: "/assets/teen-patti.png", url: "/teenpatti" },
    { title: "MATKA", img: "/games/matka.png", url: "/matkaList" },
    { title: "LUCKY 7", img: "/games/lucky7.png", url: "/lucky7" },
    { title: "12 TILES", img: "/games/12-tiles.png", url: "/titli" },
    { title: "MINES GAME", img: "/games/mines.png", url: "/mineGame" },
    { title: "WIN GO", img: "/games/wingo.png", url: "/colorGame" },
    { title: "K3", img: "/games/wingo.png", url: "/k3" },
    { title: "5D", img: "/games/wingo.png", url: "/5d" },
    { title: "SPIN WHEEL", img: "/games/spin.png", url: "/spinWheel" },
    // { title: "CRICKET", img: "/games/cricket.png", url: "/" },
  ];


  return (
    <>
      <div className="p-3">
        {/* BANNER SLIDER */}
        <div
          id="homeSlider"
          className="carousel slide mb-4"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner rounded-4 overflow-hidden">
            <div className="carousel-item active">
              <img src="/banner1.jpg" className="d-block w-100" alt="banner1" />
            </div>

            <div className="carousel-item">
              <img src="/banner2.jpg" className="d-block w-100" alt="banner2" />
            </div>

            <div className="carousel-item">
              <img src="/banner3.jpg" className="d-block w-100" alt="banner3" />
            </div>
          </div>

          {/* controls */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#homeSlider"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon"></span>
          </button>

          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#homeSlider"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon"></span>
          </button>
        </div>

        {/* GAME GRID */}
        <div className="row g-3">
          {games.map((g, i) => (
            <GameCard key={i} {...g} />
          ))}
        </div>
      </div>
    </>
  );
}
